import store from "@/store/index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { queryUserToken } from "@/api/user";
import constantRoutes, { frameInRoutes } from "./routes.js";
import { login, profile, loginPic, login2 } from "@/api/base";
import { myMenus } from "@/api/user";

// const constantRoutes = [{
//     path: '/',
//     component: Layout,
//     redirect: '/dashboard',
//     meta: {
//         title: '首页',
//         icon: 'b-home'
//     },
//     children: [{
//         path: 'dashboard',
//         name: 'dashboard',
//         component: () => import('@/views/screen/index'),
//         meta: {
//             title: store.state.settings.dashboardTitle
//         }
//     }, {
//         path: 'personal',
//         component: EmptyLayout,
//         redirect: '/personal/setting',
//         meta: {
//             title: '个人中心',
//             breadcrumb: false
//         },
//         children: [{
//             path: 'setting',
//             name: 'personalSetting',
//             component: () => import('@/views/personal/setting'),
//             meta: {
//                 title: '个人设置'
//             }
//         }, {
//             path: 'edit/password',
//             name: 'personalEditPassword',
//             component: () => import('@/views/personal/edit.password'),
//             meta: {
//                 title: '修改密码'
//             }
//         }]
//     },]
// }]
// const lastRoute = []

function getParams() {
  // var url = window.location.search;

  var url = decodeURIComponent(location.href);
  // console.log(location);
  var obj = {};
  if (url.indexOf("?") != -1) {
    var arr = url.split("?");
    var strS = arr[1].split("&");
    for (var i = 0; i < strS.length; i++) {
      let splitStr = strS[i].split("=")[1];
      if (splitStr) {
        if (!splitStr.includes("#")) {
          obj[strS[i].split("=")[0]] = splitStr;
        } else {
          obj[strS[i].split("=")[0]] = splitStr.split("#")[0];
        }
      }
    }
  }
  return obj;
}
const router = new VueRouter({
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  // routes: frameInRoutes
});
// 解决路由在 push/replace 了相同地址报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

router.beforeEach(async (to, from, next) => {
  store.state.settings.enableProgress && NProgress.start();
  //url token验证
  // let localMenu = localStorage.getItem('menu');
  // let initListItem = store.getters["user/getInitListItem"];
  if (getParams().appKey && getParams().sign && getParams().timestamp) {
    if (to.name != "login") {
      let flag = false;
      if (typeof userInfo == "object" && userInfo != null) {
        if (userInfo.userType != 6) flag = true;
      }
      if (!store.state.user.token || flag) {
        localStorage.setItem("menu", JSON.stringify({}));
        localStorage.setItem("userinfo", JSON.stringify({}));
        const obj = {
          appKey: getParams().appKey,
          sign: getParams().sign,
          timestamp: getParams().timestamp,
          area: getParams().area,
        };
        const token = await queryUserToken(obj).catch((error) => {
          next();
        });
        if (token) {
          store.commit("user/setToken", token);
          let res = await Promise.all([profile({}), myMenus({})]);
          store.commit("user/setDeadTokenTime");

          // profile({}).then(res => {
          //     this.$store.commit("user/setUserData", res);
          // });
          // //
          // this.$store.commit("menu/invalidRoutes");
          // myMenus({}).then(res => {
          //     this.$store.commit("user/setMenu", res);
          //     this.$router.push("/dashboard");
          // });
          store.commit("user/setUserData", res[0]);
          store.commit("menu/invalidRoutes");
          store.commit("user/setMenu", res[1]);
          // router.push("/dashboard");
          // router.push(initListItem.path);
        }
      }
    } else {
      next({ path: "/dashboard" });
    }
  }

  var unTokens = ["regist", "regist2", "admin", "bigScreen", "teamData", "zhuguanbumeng", "login"];
  // console.log(store.state.menu.isGenerate)
  // console.log(unTokens.indexOf(to.name) > -1);
  // console.log(store.getters['user/isLogin'] && !store.state.menu.isGenerate);
  // console.log(store.getters['user/isLogin']);

  if (unTokens.indexOf(to.name) > -1) {
    //如果不用校验登录权限
    next();
  } else if (store.getters["user/isLogin"] && !store.state.menu.isGenerate) {
    // 已经登录，但还没根据权限动态挂载路由
    // router.matcher = new VueRouter({
    //     // routes: constantRoutes
    //     routes: frameInRoutes
    // }).matcher

    var asyncRoutes = JSON.parse(JSON.stringify(store.state.user.menu));
    const accessRoutes = await store.dispatch("menu/generateRoutes", {
      asyncRoutes,
      currentPath: to.path,
    });
    accessRoutes.forEach((route) => {
      router.addRoute(route);
    });
    // matcher对象的addRoutes

    next({
      ...to,
      replace: true,
    });
  } else if (store.getters["user/isLogin"]) {
    //如果已经登录
    if (to.matched.length !== 0) {
      // 如果已登录状态下，进入登录页会强制跳转到控制台页面
      if (to.name == "login") {
        //如果是tis 和 保险 则跳转工作台，主管部门跳转数据看板
        next({
          // name: "dashboard",
          name: "login",
          replace: true,
        });
      } else if (!store.state.settings.enableDashboard && ["dashboard", "homeIndex", "homeTisindex"].includes(to.name)) {
        // 如果未开启控制台页面，则默认进入侧边栏导航第一个模块，但如果侧边栏导航没有模块，则还是进入控制台页面
        if (store.getters["menu/sidebarRoutes"].length > 0) {
          next({
            name: store.getters["menu/sidebarRoutes"][0].name,
            replace: true,
          });
        }
      } else {
        store.commit("keepAlive/add", {
          name: to.name,
          path: to.fullPath,
        });
        next();
      }
    } else {
      // 如果是通过 name 跳转，并且 name 对应的路由没有权限时，需要做这步处理，手动指向到 404 页面
      next({
        path: "/404",
      });
      return;
    }
  } else {
    if (to.name == "login" || to.name == "/") {
      next();
    } else {
      next({ name: "login" });
    }
  }

  // 百度统计代码
  // if (process.env.VUE_APP_TYPE == 'example') {
  //     if (window._hmt) {
  //         window._hmt.push(['_trackPageview', location.pathname + '#' + to.fullPath])
  //     }
  // }
  // next()

  if (store.state.menu.isGenerate) {
    //已经挂载路由
    store.commit("menu/setHeaderActived", to.path);
  }
  to.meta.title && store.commit("settings/setTitle", to.meta.title);
});

router.afterEach(() => {
  store.state.settings.enableProgress && NProgress.done();
});

export default router;
